import ComponentPositioningMixin from '@intercom/embercom-composer/components/mixins/component-positioning';
import MediaUpload from '@intercom/embercom-composer/components/mixins/media-upload';
import ImageText from '@intercom/embercom-composer/blocks/types/image-text';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import $ from 'jquery';
import { reads } from '@ember/object/computed';
import { bind, schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend(MediaUpload, ComponentPositioningMixin, {
  didInsertElement() {
    this._super(...arguments);
    this.setDimensions();
    this.renderPreview();
  },
  classNames: ['ic-popup', 'ic-popup-left', 'is-light-theme'],
  elementWidth: 480,
  previewComposer: null,
  attributeBindings: ['style'],
  arrowWidth: 20,
  uploadLabel: Em.computed('imageUrl', 'isUploadingIcon', function () {
    if (this.get('isUploadingIcon')) {
      return 'Uploading...';
    }
    if (this.get('imageUrl')) {
      return 'Change';
    } else {
      return 'Upload an image';
    }
  }),
  hasUploadError: false,
  isWithinViewport: reads('selectionCoordinates.isWithinViewport'),
  editableObject: reads('currentEditableObject'),
  uploadType: 'image',
  errorMessage: null,
  fetchFile: () => {},
  hoverAreaPadding: {
    top: 10,
    left: 5,
    right: 50,
    bottom: 10
  },
  uploadProgress(percentageComplete) {
    this.set('percentageComplete', percentageComplete);
  },
  uploadedFileName: Em.computed('imageUrl', function () {
    if (this.get('imageUrl')) {
      return this.get('imageUrl').split('/').pop();
    }
  }),
  renderPreview() {
    let block = ImageText.create({
      type: 'imageText',
      config: this.get('config'),
      text: this.get('blocksText.firstObject.text'),
      title: this.get('blocksTitle.firstObject.text'),
      imageUrl: this.get('imageUrl'),
      isPreviewMode: true
    });
    /* @pat - We are disabling sanitization here due to an issue in DOMPurify where it strips custom elements in the composer such as ic-block, zws etc */
    /* eslint-disable no-unsanitized/property */
    document.querySelector('#image-text-preview-composer').innerHTML = block.placeholderHtml;
  },
  generatePreview: Em.observer({
    dependentKeys: ['blocksText', 'blocksTitle', 'imageUrl'],
    fn() {
      this.renderPreview();
    },
    sync: true
  }),
  top: Em.computed('height', function () {
    return this.get('hoverCoordinates.top') - this.get('height') / 2;
  }),
  left: Em.computed('width', 'selectionCoordinates.left', function () {
    return this.get('width') * -1 + this.get('selectionCoordinates.left') - this.arrowWidth;
  }),
  style: Em.computed('top', 'left', 'verticalOffset', function () {
    let topPlusVerticalOffset = this.get('top') + this.get('verticalOffset');
    return sanitizeHtml(`top: ${topPlusVerticalOffset}px; left: ${this.get('left')}px; min-width: ${this.get('elementWidth')}px;`);
  }),
  verticalOffset: Em.computed(function () {
    let element = document.querySelector(`[data-id="${this.get('currentEditableObject.id')}"]`);
    if (element) {
      return element.offsetHeight / 2;
    } else {
      return 0;
    }
  }),
  setDimensions() {
    schedule('afterRender', this, function () {
      if (Em.isPresent($(this.element))) {
        let width = $(this.element).outerWidth();
        let height = $(this.element).outerHeight();
        this.setProperties({
          width,
          height
        });
      }
    });
  },
  openFileDialog() {
    let $fileInput = $('.image-text-file-upload', this.element);
    $fileInput.val(null);
    $fileInput.trigger('click');
  },
  uploadSuccess(policy) {
    this.setProperties({
      isUploadingIcon: false,
      hasUploadError: false
    });
    this.setImageUrl(policy.public_url);
  },
  uploadFail(error) {
    this.setProperties({
      hasUploadError: true,
      isUploadingIcon: false,
      errorMessage: error.message
    });
  },
  insertMediaFile(file) {
    this.set('isUploadingIcon', true);
    this.get('uploadManager').addUpload(file, bind(this, this.uploadProgress), this.get('uploadAttributes'), this.get('url'), this.get('isInline'), bind(this, this.get('fetchFile'))).then(policy => {
      this.uploadSuccess(policy);
    }).catch(error => {
      this.uploadFail(error);
    });
  },
  actions: {
    edit() {
      this.set('isEditMode', true);
    },
    openFileDialog() {
      return this.openFileDialog();
    },
    uploadImage(e) {
      if (e.target) {
        let target = e.target;
        this.insertMediaFile(target.files[0]);
      }
    }
  }
});